import { subquestionHistoryAtom, currentSubquestionAtom, initialiseSubquestionHistoryAtom, updateSubquestionHistoryAtom, clearSubquestionHistoryAtom } from './chunk-QWQRF2G4.mjs';
import { LOADING_TIMEOUT } from './chunk-QUILORVR.mjs';
import { hasSubquestions } from '@flexmr/survey-lib';
import { useAtomValue, useSetAtom } from 'jotai';
import * as React from 'react';

function useSequentialSubquestions(props) {
  const { defaultAnswerValue, question } = props;
  const formScrollRef = React.useRef(null);
  const [isInitialised, setIsInitialised] = React.useState(false);
  const [hasQuestionRendered, setHasQuestionRendered] = React.useState(
    !hasSubquestions(question)
  );
  const [isLoading, setIsLoading] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [currentAnswerValue, setCurrentAnswerValue] = React.useState(defaultAnswerValue);
  const subquestionHistory = useAtomValue(subquestionHistoryAtom);
  const currentSubquestion = useAtomValue(currentSubquestionAtom);
  const initialiseSubquestionHistory = useSetAtom(
    initialiseSubquestionHistoryAtom
  );
  const updateSubquestionHistory = useSetAtom(updateSubquestionHistoryAtom);
  const clearSubquestionHistory = useSetAtom(clearSubquestionHistoryAtom);
  const isReadyForFinalSubmission = subquestionHistory.filter((subquestion) => subquestion.submitted).length === question.rows.length - 1 && currentSubquestion?.id === subquestionHistory.at(-1)?.id;
  React.useEffect(() => {
    let timeout;
    if (!isInitialised) {
      clearSubquestionHistory();
      initialiseSubquestionHistory();
      setIsInitialised(true);
    }
    if (!hasQuestionRendered) {
      setIsLoading(true);
      setHasQuestionRendered(true);
    }
    if (!isLoading) {
      formScrollRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    }
    if (isLoading) {
      timeout = setTimeout(() => {
        setIsLoading(false);
      }, LOADING_TIMEOUT);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [
    clearSubquestionHistory,
    hasQuestionRendered,
    initialiseSubquestionHistory,
    isInitialised,
    isLoading,
    question
  ]);
  return {
    clearSubquestionHistory,
    currentAnswerValue,
    currentSubquestion,
    formScrollRef,
    hasQuestionRendered,
    initialiseSubquestionHistory,
    isInitialised,
    isLoading,
    isReadyForFinalSubmission,
    isSubmitting,
    setCurrentAnswerValue,
    setHasQuestionRendered,
    setIsInitialised,
    setIsLoading,
    setIsSubmitting,
    subquestionHistory,
    updateSubquestionHistory
  };
}

export { useSequentialSubquestions };
//# sourceMappingURL=chunk-3U5Y3MI7.mjs.map
//# sourceMappingURL=chunk-3U5Y3MI7.mjs.map